import React from "react";
import PropTypes from "prop-types";
import CenterModal from "../UI/Modal/CenterModal";

const DeleteNoteModal = ({ localisedValues, isDeleteNoteMOdalOpen, handleCloseDeleteNoteModal, handleDeleteNote, deleteNoteLoading }) => {
    const header = (
        <>
            <h5 className='modal-title'>{localisedValues["delete_Note"]}</h5>
            <button
                type='button'
                className='btn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
                onClick={handleCloseDeleteNoteModal}
                onKeyDown={() => {}}
                disabled={deleteNoteLoading}
            >
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const body = (
        <div className='cms-modal-text'>
            <p>{localisedValues["want_delete_this_note"]}</p>
        </div>
    );

    const footer = (
        <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
            <div className='button'>
                <button className='btn default-btn-link' data-bs-dismiss='modal' onClick={handleCloseDeleteNoteModal} disabled={deleteNoteLoading}>
                    {localisedValues["cancel"]}
                </button>
            </div>
            <div className='button'>
                <button className='btn default-btn-primary' onClick={handleDeleteNote} disabled={deleteNoteLoading}>
                    {localisedValues["delete_lable"]}
                </button>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={isDeleteNoteMOdalOpen}
            closeModal={handleCloseDeleteNoteModal}
            modalClass='default-modal modal-small mob-bottom-top'
            className='modal-dialog-centered'
            bodyClassName='default-custom-scroll'
            header={header}
            body={body}
            footer={footer}
            backdrop={"static"}
            keyboard={false}
        />
    );
};

DeleteNoteModal.propTypes = {
    localisedValues: PropTypes.object,
    isDeleteNoteMOdalOpen: PropTypes.bool,
    handleCloseDeleteNoteModal: PropTypes.func,
    handleDeleteNote: PropTypes.func,
    deleteNoteLoading: PropTypes.bool,
};

export default DeleteNoteModal;
